<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <h5>Companiile mele</h5>
        </div>
        <div class="card-body">
          <div class="btn-popup pull-left">
            <!--            <button type="button" class="btn btn-primary" data-toggle="modal" data-original-title="test"-->
            <!--                    data-target="#exampleModal" (click)="open(content)">Adauga persona juridica</button>-->
            <button type="button" class="btn btn-primary" (click)="openCreationForm()" >Adauga
              persona juridica
            </button>
          </div>
          <div id="batchDelete" class="category-table custom-datatable">
            <div class="table-responsive">
              <ng2-smart-table [settings]="settings" [source]="companies"></ng2-smart-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
